import GeneroSpedService from "@/services/GeneroSpedService";

export const generoSped = {
  namespaced: true,
  state: {
    generoSped: {},
  },
  actions: {
    getGeneroSped({ commit }, payload) {
      return GeneroSpedService.GetGeneroSped(payload).then(
        (generoSped) => {
          return Promise.resolve(generoSped);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postGeneroSped({ commit }, payload) {
      return GeneroSpedService.PostGeneroSped(payload).then(
        (generoSped) => {
          return Promise.resolve(generoSped);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putGeneroSped({ commit }, payload) {
      return GeneroSpedService.PutGeneroSped(payload).then(
        (generoSped) => {
          return Promise.resolve(generoSped);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteGeneroSped({ commit }, payload) {
      return GeneroSpedService.DeleteGeneroSped(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getGeneroSpedOData({ commit }, payload) {
      return GeneroSpedService.GetGeneroSpedOData(payload).then(
        (generoSped) => {
          return Promise.resolve(generoSped);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default generoSped;
